import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Banner = styled.section`
  padding: 3.75rem 0;
  text-align: center;
  margin: 0 auto;
  background-color: ${({ isTransparent }) =>
    isTransparent ? 'transparent' : themeGet('colors.grey')};

  ${({ showDivider }) =>
    showDivider &&
    css`
      border-bottom: 1px solid ${themeGet('colors.divider-grey-dark')};
    `};

  @media (max-width: ${themeGet('breakpoints.lg')}) {
    padding: 2.5rem 0;
  }

  &.no-margin {
    padding: 0 2rem;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      padding: 0 1rem;
    }
  }

  &.no-margin-top {
    padding: 0 2rem 3.75rem;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      padding: 0 1rem 2rem;
    }
  }

  &.no-margin-bottom {
    padding: 3.75rem 2rem 0;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      padding: 2.5rem 1rem 0;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    width: 100%;
    max-width: 60rem;
    margin: 0 auto;
    text-align: center;

    @media (max-width: ${themeGet('breakpoints.lg')}) {
      width: 100%;
      max-width: 100%;
    }

    ${({ subHeading }) =>
      subHeading &&
      css`
        margin: 0 auto 1rem;
      `};
  }

  p {
    width: 100%;
    max-width: 60rem;
    line-height: 1.67;
    margin: 0 auto;
    text-align: center;

    @media (max-width: ${themeGet('breakpoints.lg')}) {
      width: 100%;
      max-width: 100%;
    }

    a {
      color: inherit;
      text-decoration: underline;
    }
  }
`;

export const CtaContainer = styled.div`
  margin-top: 2.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  a,
  button {
    margin: 0 auto;
  }
`;
